import { render, staticRenderFns } from "./RedeemButton.vue?vue&type=template&id=69bce101&scoped=true&"
import script from "./RedeemButton.vue?vue&type=script&lang=js&"
export * from "./RedeemButton.vue?vue&type=script&lang=js&"
import style0 from "./RedeemButton.vue?vue&type=style&index=0&id=69bce101&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bce101",
  null
  
)

export default component.exports